import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[700px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            {contactData.title}
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-xl mx-auto">
            {contactData.description}
          </p>
        </div>

        <div className="bg-background-100 rounded-3xl border border-background-200/70 p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center p-5 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div className="text-sm text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-foreground-900 font-medium text-sm break-all">{contactData.email}</div>
            </div>
            <div className="text-center p-5 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div className="text-sm text-foreground-500 mb-1">微信公众号</div>
              <div className="text-foreground-900 font-medium text-sm">{contactData.wechat}</div>
            </div>
            <div className="text-center p-5 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-qq-line text-xl text-secondary-600"></i>
              </div>
              <div className="text-sm text-foreground-500 mb-1">QQ群</div>
              <div className="text-foreground-900 font-medium text-sm">{contactData.qq}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}